export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";

export async function logApiError(response, context = "API request failed") {
  if (process.env.NODE_ENV !== "development") return;

  let body = "";
  try {
    body = await response.clone().text();
  } catch {
    body = "";
  }

  console.error(context, {
    status: response.status,
    statusText: response.statusText,
    body,
  });
}

export function logUnexpectedError(error, context = "Unexpected error") {
  if (process.env.NODE_ENV !== "development") return;
  console.error(context, error);
}
